// 菜单，顶栏

export default [
    {
        path: '/bpm/my/todoTaskList',
        title: '个人办公',
        //icon: 'md-home',
        hideSider: true,
        name: 'home'
    },
    {
        path: '/org',
        title: '组织管理',
        hideSider: true,
        name: 'org'
    },
    {
        path: '/notice',
        title: '内容管理',
        hideSider: true,
        name: 'cms'
    },
    {
        path: '/sbgl',
        title: '设备管理',
        hideSider: true,
        name: 'sbgl'
    }
];
